export const isEmbeddedReadOnly = (() => {
  if (typeof window === 'undefined') {
    return false
  }

  try {
    return window.parent !== window
  } catch {
    return true
  }
})()

// Undocumented escape hatch: SDK consumers can pass __persist to Xiagram.init to opt back into localStorage persistence while embedded.
const persistOverride = (() => {
  if (typeof window === 'undefined') {
    return false
  }
  return new URLSearchParams(window.location.search).get('persist') === 'true'
})()

export const shouldPersistState = !isEmbeddedReadOnly || persistOverride
